/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

'use strict';

const config = require('./config.json');

module.exports = (() => {
    const environment = process.env.REACT_APP_ENVIRONMENT;
    let environmentConfig = {};
    if (environment) {
        try {
            environmentConfig = require(`./${environment}.config.json`);
            console.info(`Using configuration file for the environment ${environment}`);
        } catch (ex) {
            console.warn(`Missing configuration file for the environment ${environment}`);
        }
    }

    return Object.assign({}, config, environmentConfig);
})();



// WEBPACK FOOTER //
// ./src/config/config.js